var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"student-page"},[_c('page-title',{attrs:{"showExport":""}},[_vm._v(_vm._s(_vm.$t('newsletters.info')))]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }